import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bindObjectValue'
})
export class BindObjectValuePipe implements PipeTransform {

   transform(value: any, key: string | string[] | any): any {
    // console.log('bindObjectValuePipe', value, key);
    if (!value || !key) return '-';
    if (Array.isArray(key)) {
    // console.log(key);
      const parts = key.map(k => this.multi_value_show(value, k)).filter(Boolean);
      return parts.length > 0 ? parts.join(' ') : '-';
    }
    return this.multi_value_show(value, key) ?? '-';
  }

  multi_value_show(obj: any, path: string): any {
    try {
      const keys = path.split('.');
      let result = obj;
      for (let k of keys) {
        if (result && typeof result === 'object' && k in result) {
          result = result[k];
        } else {
          return '';
        }
      }
      result = this.check_boolean(result, path)
      return result ?? '';
    } catch {
      return '';
    }
  }

  check_boolean(value: any, key: any) {
    const key_lower = key.toLowerCase();
    if (key_lower.includes('active')) {
      return value ? 'Enable' : 'Disable';
    } else {
      return value;
    }
  }

}
